import React, { useState, useCallback, useEffect, useContext } from "react"
import Select, { components } from "react-select"
import Modal, {
  ModalContent,
  ModalHeader,
  ModalBtnGroup,
} from "../../components/Modal"
import CsvDownloader from "react-csv-downloader"
import _ from "lodash"
import AppContext from "../../shared/AppContext"

import "./style.scss"

function SectorFilter(props) {
  const [selection, setSection] = useState({})
  const [isModalOpen, setIsModalOpen] = useState(false)
  const { trackEvent } = useContext(AppContext)

  let sectorGroup = _.groupBy(props.vendors, (vendor) => vendor.sectorName)

  let selectOptions = []

  for (const [sector, vendors] of Object.entries(sectorGroup)) {
    selectOptions.push({ label: sector, value: sector, sector: sector })
    for (const vendor of vendors) {
      const existingOption = selectOptions.find(
        (option) => option.label === vendor.productName
      )
      if (!existingOption) {
        selectOptions.push({
          label: vendor.productName,
          value: vendor.productName,
          sector: sector,
          vendor: vendor.productName,
        })
      }
    }
  }

  useEffect(() => {
    if (!isModalOpen) {
      setSection({})
    }
  }, [isModalOpen])

  const sectorRef = useCallback((node) => {
    if (node !== null) {
      if (node.attributes["data-sector"].value === selection.sector) {
        node.scrollIntoView()
      }
    }
  })

  const formatCSV = () => {
    return props.vendors.map((vendor) => {
      return { Vendor: vendor.productName, Sector: vendor.sectorName }
    })
  }

  const handletoggle = (sector) => {
    if (selection.sector === sector) {
      setSection({})
    } else {
      setSection({ sector: sector })
    }
  }

  const DropdownIndicator = (props) => {
    return (
      <components.DropdownIndicator {...props}>
        <i className="fas fa-search"></i>
      </components.DropdownIndicator>
    )
  }

  return (
    <React.Fragment>
      <span
        className="sector-selector"
        data-cy="sector-button"
        onClick={() => {
          trackEvent("sector filter click")
          setIsModalOpen(true)
        }}
      >
        <strong>{Object.keys(sectorGroup).length} sectors.</strong>
      </span>
      <Modal
        className="sector-filter-modal"
        isOpen={isModalOpen}
        close={() => setIsModalOpen(false)}
      >
        <ModalContent style={{ maxWidth: 690 }}>
          <p className="instructions">
            Scroll through our Technologies by Sectors
          </p>
          <ModalHeader close={() => setIsModalOpen(false)} />
          <Select
            id="sector-filter-input"
            options={selectOptions}
            isClearable={true}
            components={{ DropdownIndicator }}
            placeholder="Search for a Vendor or Sector"
            onChange={(value) => (!value ? setSection({}) : setSection(value))}
          />
          <div className="sector-filter-view">
            {Object.entries(sectorGroup).map(([sector, vendors], index) => {
              return (
                <section
                  className="sector-filter-section"
                  key={index}
                  data-cy="sector"
                >
                  <h3
                    ref={sectorRef}
                    className="sector-filter-title"
                    onClick={() => {
                      handletoggle(sector)
                    }}
                    data-sector={sector}
                    data-open-indicator={
                      selection.sector === sector ? "-" : "+"
                    }
                  >
                    {sector}
                  </h3>
                  <ul
                    className="sector-filter-vendors"
                    data-cy="vendors"
                    data-open={selection.sector === sector}
                  >
                    {vendors.map((vendor, index) => {
                      return (
                        <li
                          key={index}
                          data-highlight={
                            selection.vendor === vendor.productName
                          }
                        >
                          {vendor.productName}
                        </li>
                      )
                    })}
                  </ul>
                </section>
              )
            })}
          </div>
          <ModalBtnGroup alignRight>
            <CsvDownloader
              filename="Sectors"
              extension=".csv"
              separator=","
              datas={formatCSV()}
            >
              <button className="btn sector-filter-download">
                Download all Vendors
              </button>
            </CsvDownloader>
          </ModalBtnGroup>
        </ModalContent>
      </Modal>
    </React.Fragment>
  )
}

export default SectorFilter
